import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { WalletProvider } from './contexts/WalletContext'
import { MessagingProvider } from './contexts/MessagingContext'
import Layout from './components/Layout'
import Home from './pages/Home'
import HDH from './pages/HDH'
import LogoTest from './pages/LogoTest'
import Profile from './pages/Profile'
import CreateProfile from './pages/CreateProfile'
import Upload from './pages/Upload'
import Messages from './pages/Messages'
import WebsiteBuilder from './components/WebsiteBuilder/WebsiteBuilder'
import TemplateMarketplace from './pages/TemplateMarketplace'
import CreateTemplate from './pages/CreateTemplate'
import CreatorDashboard from './pages/CreatorDashboard'
import Monetization from './pages/Monetization'
import BlockchainDevelopment from './pages/BlockchainDevelopment'
import NotFound from './pages/NotFound'

function App() {
  return (
    <WalletProvider>
      <MessagingProvider>
        <Router>
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/hdh" element={<HDH />} />
              <Route path="/logo-test" element={<LogoTest />} />
              <Route path="/u/:handle" element={<Profile />} />
              <Route path="/create-profile" element={<CreateProfile />} />
              <Route path="/upload" element={<Upload />} />
              <Route path="/messages" element={<Messages />} />
              <Route path="/website-builder" element={<WebsiteBuilder />} />
              <Route path="/template-marketplace" element={<TemplateMarketplace />} />
              <Route path="/create-template" element={<CreateTemplate />} />
              <Route path="/creator-dashboard" element={<CreatorDashboard />} />
              <Route path="/monetization" element={<Monetization />} />
              <Route path="/blockchain-development" element={<BlockchainDevelopment />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Layout>
        </Router>
      </MessagingProvider>
    </WalletProvider>
  )
}

export default App
